import { render, staticRenderFns } from "./UploadLuminex.vue?vue&type=template&id=1741e79e&"
import script from "./UploadLuminex.vue?vue&type=script&lang=js&"
export * from "./UploadLuminex.vue?vue&type=script&lang=js&"
import style0 from "./UploadLuminex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports